export const currentBusiness = state => state.currentBusiness
